import { ErrorHandling } from "../Logging/ErrorHandling";
import { Logger } from "../Logging/Log";

class FetchError extends Error {
  type = "FetchError";
  constructor(
    public category: string,
    public url: RequestInfo | URL,
    public origError: unknown
  ) {
    super("FetchError: Failed to fetch");
  }
}

let origFetch: (input: RequestInfo | URL, init?: RequestInit | undefined) => Promise<Response>;
export function patchFetch() {
  origFetch = window.fetch;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((globalThis as any).EDITOR?.EDIT_MODE) {
    return;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).vanillaFetch = origFetch;
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    return fetchWrapper("thirdparty", input, init);
  };
}

export async function fetchWrapper(category: string, url: RequestInfo | URL, init?: RequestInit) {
  try {
    return await origFetch(url, init);
  } catch (e) {
    throw new FetchError(category, url, e);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function checkForFetchError(e: any) {
  const errors = ErrorHandling.flattenErrors(e);
  const fetchError = errors.find((error) => {
    return error && error.type === "FetchError";
  });
  if (fetchError) {
    Logger.logInfo(
      "Fetch failure",
      { category: fetchError.category, url: fetchError.url, origError: fetchError.origError },
      { logOnce: true }
    );
  }
  return fetchError !== undefined;
}
